<template>
  <div class="report_forms_preview" v-loading="loading">
    <div class="b0">这是为您生成的第{{ reactiveData.data.reportid }}份周报</div>
    <div class="b1 bg pd">
      <div class="mr5">
        <img src="@/assets/img/account_icon.png" width="35" />
      </div>
      <div>
        <div class="t1">
          {{ reactiveData.data.cname }}
        </div>
        <div class="t2">{{ reactiveData.data.desc }}</div>
      </div>
    </div>
    <div class="pd">
      <div class="b2 bg pd bo mb">
        <el-space class="space_fill" direction="vertical" fill :size="20">
          <div class="flex">
            <div class="item">
              <div class="t1">周播放</div>
              <div class="t2 ellipsis">
                {{ reactiveData.data.week_play }}
                <i>次</i>
              </div>
            </div>
            <div class="item">
              <div class="t1">周互动</div>
              <div class="t2 ellipsis">
                {{ reactiveData.data.week_interaction }}
                <i>次</i>
              </div>
            </div>
            <div class="item">
              <div class="t1">周私信</div>
              <div class="t2 ellipsis">
                {{ reactiveData.data.week_dialogu }}
                <i>次</i>
              </div>
            </div>
            <!-- <div class="item">
              <div class="t1">周评论</div>
              <div class="t2 ellipsis">
                {{ reactiveData.data.week_comment }}
                <i>个</i>
              </div>
            </div> -->
            <div class="item">
              <div class="t1">周意向</div>
              <div class="t2 ellipsis">
                {{ reactiveData.data.week_intention }}
                <i>个</i>
              </div>
            </div>
          </div>
          <!-- <div class="flex">
            <div class="item">
              <div class="t1">周创建视频</div>
              <div class="t2">
                {{ reactiveData.data.week_create_video }}
                <i>次</i>
              </div>
            </div>
            <div class="item">
              <div class="t1">周发布视频</div>
              <div class="t2">
                {{ reactiveData.data.week_publish_video }}
                <i>次</i>
              </div>
            </div>
            <div class="item">
              <div class="t1">周播放</div>
              <div class="t2">
                {{ reactiveData.data.week_play }}
                <i>次</i>
              </div>
            </div>
            <div class="item">
              <div class="t1">周关键词</div>
              <div class="t2">
                {{ reactiveData.data.week_keyword }}
                <i>个</i>
              </div>
            </div>
          </div> -->
          <div class="flex">
            <div class="item">
              <div class="t1">总播放</div>
              <div class="t2">{{ reactiveData.data.play_count }}</div>
            </div>
            <div class="item">
              <div class="t1">总互动</div>
              <div class="t2">{{ reactiveData.data.total_interaction }}</div>
            </div>
            <div class="item">
              <div class="t1">总评论</div>
              <div class="t2">{{ reactiveData.data.comment_count }}</div>
            </div>
            <div class="item">
              <div class="t1">总点赞</div>
              <div class="t2">{{ reactiveData.data.digg_count }}</div>
            </div>
          </div>
        </el-space>
      </div>
      <div class="b3 bg pd bo mb">
        <el-row justify="space-between">
          <div class="title">作品数据</div>
          <div v-if="reactiveData.data.week_video_json?.daydata">
            {{ _.last(reactiveData.data.week_video_json.daydata) }}~{{
              moment(_.last(reactiveData.data.week_video_json.daydata), 'MM-DD')
                .add(6, 'days')
                .format('MM-DD')
            }}发布作品{{ _.last(reactiveData.data.week_video_json.date2) }}条
          </div>
        </el-row>
        <ChartBar
          :chartData="reactiveData.chartData3"
          :chartOptions="reactiveData.chartData3Options"
        />
      </div>
      <div class="b3 bg pd bo mb">
        <el-row justify="space-between">
          <div class="title">
            {{ reactiveData.chartData1.datasets[0].label }}
          </div>
          <div v-if="reactiveData.data.week_aiservice_json?.daydata">
            {{ _.last(reactiveData.data.week_aiservice_json.daydata) }}~{{
              moment(
                _.last(reactiveData.data.week_aiservice_json.daydata),
                'MM-DD'
              )
                .add(6, 'days')
                .format('MM-DD')
            }}销售线索{{
              _.last(reactiveData.data.week_aiservice_json.date1)
            }}条
          </div>
        </el-row>
        <ChartLine :chartData="reactiveData.chartData1" />
      </div>
      <div class="b3 bg pd bo mb">
        <el-row justify="space-between">
          <div class="title">
            {{ reactiveData.chartData2.datasets[0].label }}
          </div>
          <div v-if="reactiveData.data.week_clue_json?.daydata">
            {{ _.last(reactiveData.data.week_clue_json.daydata) }}~{{
              moment(_.last(reactiveData.data.week_clue_json.daydata), 'MM-DD')
                .add(6, 'days')
                .format('MM-DD')
            }}互动事件{{ _.last(reactiveData.data.week_clue_json.date1) }}条
          </div>
        </el-row>
        <ChartLine :chartData="reactiveData.chartData2" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watchEffect, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import { report_forms_week_find } from '@/utils/api'
import ChartBar from '@/components/ChartBar'
import ChartLine from '@/components/ChartLine'

const route = useRoute()

const store = useStore()
const { state } = store
const { loading } = toRefs(state)

const props = defineProps({
  row: { type: Object, default: () => ({}) },
})
const { row } = toRefs(props)

const reactiveData = reactive({
  data: {},
  chartData1: {
    labels: [],
    datasets: [
      {
        label: '销售线索',
        data: [],
        backgroundColor: '#016FED',
      },
    ],
  },
  chartData2: {
    labels: [],
    datasets: [
      {
        label: '智能客服',
        data: [],
        backgroundColor: '#016FED',
      },
    ],
  },
  chartData3: {
    labels: [],
    datasets: [
      {
        label: '作品数据',
        data: [],
        backgroundColor: '#016FED',
      },
    ],
  },
  chartData3Options: {
    plugins: {
      legend: {
        labels: {
          color: '#fff',
          boxWidth: 12,
          boxHeight: 12,
          font: {
            size: 14,
          },
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: '#fff',
        },
      },
      y: {
        beginAtZero: true,
        type: 'linear',
        display: true,
        position: 'left',
        ticks: {
          color: '#fff',
        },
      },
      y2: {
        beginAtZero: true,
        type: 'linear',
        display: true,
        position: 'right',
        grid: {
          drawOnChartArea: false,
        },
        ticks: {
          color: '#fff',
        },
      },
    },
  },
})

watchEffect((onInvalidate) => {
  let id = route.params?.id || row.value?.id
  if (id) {
    const controller = new AbortController()
    report_forms_week_find(
      { id, code: row.value.code, ...route.params },
      { signal: controller.signal }
    ).then(({ data: res }) => {
      reactiveData.data = res.data
      reactiveData.chartData1 = {
        labels: res.data.week_aiservice_json.daydata,
        datasets: [
          {
            label: '销售线索',
            data: res.data.week_aiservice_json.date1,
            backgroundColor: '#016FED',
            borderColor: '#016FED',
            borderWidth: 3,
          },
          {
            label: '带电话线索',
            data: res.data.week_aiservice_json.date2,
            backgroundColor: '#F93637',
            borderColor: '#F93637',
            borderWidth: 3,
          },
        ],
      }
      reactiveData.chartData2 = {
        labels: res.data.week_clue_json.daydata,
        datasets: [
          {
            label: '互动事件',
            data: res.data.week_clue_json.date1,
            backgroundColor: '#016FED',
            borderColor: '#016FED',
            borderWidth: 3,
          },
          {
            label: '智能客服',
            data: res.data.week_clue_json.date2,
            backgroundColor: '#F93637',
            borderColor: '#F93637',
            borderWidth: 3,
          },
        ],
      }
      reactiveData.chartData3 = {
        labels: res.data.week_video_json.daydata,
        datasets: [
          {
            label: '创建作品',
            data: res.data.week_video_json.date1,
            backgroundColor: '#5470C6',
            borderColor: '#5470C6',
            borderWidth: 3,
            yAxisID: 'y',
            order: 3,
          },
          {
            label: '发布作品',
            data: res.data.week_video_json.date2,
            backgroundColor: '#91CC75',
            borderColor: '#91CC75',
            borderWidth: 3,
            yAxisID: 'y',
            order: 2,
          },
          {
            type: 'line',
            label: '作品播放',
            data: res.data.week_video_json.date3,
            backgroundColor: '#FAC858',
            borderColor: '#FAC858',
            borderWidth: 3,
            yAxisID: 'y2',
            order: 1,
            tension: 0.4,
          },
        ],
      }

      if (route.params?.id) {
        document.title =
          reactiveData.data.cname + '第' + reactiveData.data.reportid + '份周报'
      }
    })
    onInvalidate(() => {
      controller.abort()
    })
  }
})
</script>

<style scoped lang="scss">
.report_forms_preview {
  background-color: #0c1429;
}
.bg {
  background-color: #121f38;
}
.bo {
  border: 2px solid #223c6c;
  border-radius: 4px;
}
.pd {
  padding: 12px;
}
.mb {
  margin-bottom: 12px;
}
.b1 {
  /* height: 120px;
  height: 77px; */
  display: flex;
  /* flex-direction: column;
  justify-content: space-between; */
}
.b2 {
  .flex {
    display: flex;
    justify-content: space-between;
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .t1 {
        color: #8b99b2;
      }
      .t2 {
        margin-top: 12px;
        font-size: 24px;
        font-weight: bold;
        color: #fff;
        i {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
        }
      }
    }
  }
}
.b3 {
  .title {
    font-weight: bold;
    font-size: 16px;
  }
}
.b0 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0d3096;
  height: 60px;
  font-size: 20px;
}
</style>
